<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <vx-card title="All Orders">
      <div slot="no-body" class="mt-4">
        <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="ordersHistory" class="table-dark-inverted ml-4 mr-4">

          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between ">

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ ordersHistory.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : ordersHistory.length }} of {{ queriedItems }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>

                <vs-dropdown-item @click="itemsPerPage=4">
                  <span>4</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th sort-key="id">Order ID</vs-th>
            <vs-th sort-key="status">Status</vs-th>
            <vs-th sort-key="price">Amount</vs-th>
            <vs-th sort-key="name">Customer Name</vs-th>        
            <vs-th sort-key="deal">DEAL STAGE</vs-th>        
            <vs-th sort-key="products">ITEMS PURCHASED</vs-th>
            <vs-th sort-key="date">Date</vs-th> 
          </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td>
                    <p class="product-name font-medium truncate">#{{ tr.id }}</p>
                  </vs-td>

                  <vs-td>
                    <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + getOrderStatusColor(tr.status) "></div>{{tr.status}}</span>
                  </vs-td>

                  <vs-td>
                    <p class="product-price">{{ tr.price }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="product-category">{{ tr.customer}}</p>
                  </vs-td>

                  <vs-td>
                      <span>{{dealStatus(tr.status)}}</span>
                      <vs-progress :percent="dealPercent(tr.status)" :color="getOrderStatusColor(tr.status)"></vs-progress>
                  </vs-td>

                  <vs-td>
                    <p class="products">{{ tr.products }}</p>
                  </vs-td>

                  <vs-td >
                    <p class="product-date">{{ getFormatedDate(tr.date) }}</p>
                  </vs-td>

                </vs-tr>
              </tbody>
            </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import moduleDataList from '@/store/data-list/moduleDataList.js'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
      title: '',
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    ordersHistory () {
      if('orderHistory' in this.$store.state.AppActiveUser.cards){
        return this.$store.state.AppActiveUser.cards.orderHistory
      } else {            
        this.$store.commit('UPDATE_ORDER_HISTORY', this.$store.state.AppActiveUser.defaultState.cards.orderHistory)
        return this.$store.state.AppActiveUser.defaultState.cards.orderHistory
      }
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.ordersHistory.length
    }
  },
  methods: {
    dealPercent(status){
        switch (status) {
            case "pending":
            return 50;
            
            case "failed":
            return 60;
            
            case "processing":
            return 80;
            
            case "cancelled":
            return 80;
            
            case "completed":
            return 100;
            
            case "on-hold":
            return 60;
            
            case "refunded":
            return 100;
            
            default:
            return 30;
        }
    },
    dealStatus(status){
        switch (status) {
            case "pending":
            return "checkout pending";
            
            case "failed":
            return "checkout abandoned";
            
            case "processing":
            return "checkout completed";
            
            case "cancelled":
            return "cancelled";
            
            case "completed":
            return "shipped";
            
            case "on-hold":
            return "checkout pending";
            
            case "refunded":
            return "processed";
            
            default:
            return "checkout abandoned";
        }
    },
    getOrderStatusColor (status) {
      if (status === 'cancelled' || status === 'pending' || status === 'refunded')   return 'dark'
      if (status === 'completed') return 'primary'
      if (status === 'processing')   return 'success'
      if (status === 'on_hold') return 'warning'
      if (status === 'failed')  return 'danger'
      return 'warning'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    getFormatedDate(thedate) {  
      var dt = new Date( Number(thedate) );
      var dd = dt.getDate();
      var mm = dt.getMonth() + 1; //January is 0!
      var yyyy = dt.getFullYear();
      if (dd < 10) { dd = '0' + dd; } 
      if (mm < 10) { mm = '0' + mm; } 
      
      return mm + '-' + dd + '-' + yyyy + " " + dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    },
  },
  created () {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.$store.dispatch('dataList/fetchDataListItems')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

